// @ts-nocheck
import styled from 'styled-components';

import { Eyebrow, Headline, Cta as CtaComponent } from 'components/atoms';
import { getThemeColor } from 'utils/get-theme-color';
import { container } from 'styles/grid';
import { minWidth, maxWidth } from 'styles/media-queries';
import { Markdown } from 'components/molecules';

import { multiple } from 'components/atoms/arrow-cta/ArrowCta.styled';
import {
  articleMargins,
  sectionMargins,
  spacer16,
  spacer24,
  spacer64,
  spacer80,
} from 'styles/spacers';

export const VideoFeatureCard = styled.section`
  ${container}
  ${props => (props.theme.isArticleMargin ? articleMargins : sectionMargins)}
  ${({ theme }) =>
    theme.isArticleMargin &&
    `
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  `}

  color: ${({ theme }) => getThemeColor(theme.themeKey)};
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.backgroundColor};
  border-radius: 8px;
  ${({ theme }) =>
    theme.isArticleMargin &&
    `
      grid-column: 3 / 11;
      border-radius: 8px;
      padding: ${spacer24} ${spacer16};
      background-color: ${theme.backgroundColor};
    `}

  ${minWidth.lg`
    padding: ${({ theme }) => {
      if (theme.isArticleMargin) return `${spacer80} ${spacer64}`;
      if (theme.isOverlayMargin) return `${spacer80} 0`;
      return `${spacer80} ${spacer64}`;
    }};
    display: flex;
    flex-direction: ${({ theme }) =>
      theme.videoRight ? 'row' : 'row-reverse'};
    justify-content: space-between;
    gap: ${({ theme }) => (theme.videoRight ? '2rem' : '4rem')};
    align-items: center;
  `}

  ${maxWidth.sm`
    padding: ${({ theme }) => {
      if (theme.isArticleMargin) return `${spacer24} ${spacer16}`;
      if (theme.isOverlayMargin) return `${spacer24} 0`;
      return `${spacer24} ${spacer16}`;
    }};
  `}
`;

export const VideoContainer = styled.div`
  display: block;
  margin-bottom: 4rem;
  overflow: hidden;
  position: relative;
  flex-grow: 1;

  ${minWidth.lg`
    margin-bottom: 0;
    width: 100%;
    max-width: 600px;

     ${({ theme }) =>
       theme.hasVerticalVideo &&
       `
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      max-width: 400px;
    `}
  `}
`;

export const AudioToggleContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const Content = styled.div`
  margin-bottom: 4.3rem;
  flex-grow: 1;

  ${minWidth.lg`
    margin-bottom: 0;
    padding-right: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 600px;
  `}
`;

export const HeadlineContainer = styled.div`
  margin-bottom: 1.6rem;

  ${minWidth.lg`
    margin-bottom: 0;
    ${({ theme }) =>
      (theme.hasVideo || theme.hasVerticalVideo) &&
      `
        margin-bottom: 1.6rem;
      `}
  `}
`;

export const ColumnList = styled(props => <Markdown {...props} />)`
  margin: 2.4rem 0 5rem 0;
`;

export const TitleEyebrow = styled(Eyebrow)`
  margin-bottom: 0.4rem;

  ${minWidth.lg`
    margin-bottom: 0.8rem;
  `}
`;

export const Title = styled(Headline)`
  color: ${({ theme }) => theme.titleColor || getThemeColor(theme.themeKey)};
  font-size: ${({ theme }) => (theme.isArticleMargin ? '4rem' : '6rem')};
`;

export const DescriptionContainer = styled.div`
  ${minWidth.lg`
  grid-column: 7 / span 5;
`}

  li {
    font-weight: bold;
  }
`;

export const CtasContainer = styled.div`
  margin-top: 3.2rem;
`;

export const Cta = styled(CtaComponent)`
  ${multiple};
`;
